<template>
  <div className="App">
    <div
      className="titleImage"
      :style="{
        'background-image':
          'url(' + require('@/assets/images/road-in-forest.jpg') + ')',
      }"
    >
      <Title />
    </div>
    <Page type="homeTextField" />
    <div
      id="about"
      class="SectionHeader"
      :style="{
        'background-image':
          'url(' + require('@/assets/images/mountains-water.jpg') + ')',
      }"
    >
      <h1>OM MIG</h1>
    </div>
    <Page type="aboutTextField" />
    <Contact />
  </div>
</template>

<script>
import Title from "@/Components/Title.vue";
import Page from "@/Views/Page.vue";
import Contact from "@/Views/ContactView.vue";

export default {
  setup() {},
  components: {
    Title,
    Page,
    Contact,
  },
};
</script>

<style scoped>
body > #root > div {
  height: 100vh;
}

/* Create a Parallax Effect */
.bgimg-1,
.bgimg-2,
.bgimg-3 {
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

/* First image (Logo. Full height) */
.titleImage {
  min-height: 100vh;
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

/* Turn off parallax scrolling for tablets and phones */
@media only screen and (max-device-width: 1600px) {
  .bgimg-1,
  .bgimg-2,
  .bgimg-3 {
    background-attachment: scroll;
    min-height: 400px;
  }
}

.title {
  font-family: "Inconsolata", monospace;
  background: #282c34;
  margin: 0.5em 1em;
  text-align: center;
  font-size: 2em;
  color: whitesmoke;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  letter-spacing: 10px;
  animation-timing-function: ease;
  animation: slideIn 1.5s;
}
</style>
